export default {
  DestinationByThemeCard__LINK_ARIA_LABEL: (options) =>
    `View ${options.stationName} destination details`,
};
